import { render, staticRenderFns } from "./reservationComfirm.vue?vue&type=template&id=54876a42&scoped=true"
import script from "./reservationComfirm.vue?vue&type=script&lang=js"
export * from "./reservationComfirm.vue?vue&type=script&lang=js"
import style0 from "./reservationComfirm.vue?vue&type=style&index=0&id=54876a42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54876a42",
  null
  
)

export default component.exports